import { isTokenExpired } from '@fubotv/utils';
import { negate } from 'lodash-es';
import { getToken } from './manageTokens.js';
import refreshTokens from './refreshTokens.js';
import typeofOrNull from '../misc/typeofOrNull.js';
const functionName = 'getValidToken';
const notExpired = negate(isTokenExpired);
export async function getValidToken(client, tokenType = 'idToken', tokenValidator = notExpired, tokenRefresher = refreshTokens) {
    const { getState } = client;
    if (typeof getState !== 'function') {
        const message = `
      ${functionName} expected the client argument to contain a
      getState property of type function. Instead it received a something of
      type ${typeofOrNull(getState)}.
    `;
        throw new Error(message);
    }
    const token = getToken(client, tokenType);
    if (typeof token !== 'string') {
        const message = `
      ${functionName} expected an id token to be a string.
      Instead it found something of type
      ${typeofOrNull(token)}. Please make sure you only call this
      method when your client has authenticated and has a valid id token.
    `;
        throw new Error(message);
    }
    if (tokenValidator(token, 60))
        return token;
    // automatically renew tokens
    return await tokenRefresher(client);
}
export default async function getTokenHeader(client) {
    const token = await getValidToken(client);
    return {
        authorization: 'Bearer ' + token,
    };
}
